import { trackUserError } from "@claroty/utilities/tracking/manualTracking";
import { t } from "@lingui/core/macro";
import { errorNotification, infoNotification } from "../../app/Notifications/notifications";

const PASSWORD_EXPIRED_MESSAGE_TIMEOUT_SECONDS = 30;

// If the password is almost (or already) expired, shows a warning toast.
// Returns true if the password is already expired
export function showPasswordExpiryWarningToast(passwordDaysLeft) {
    if (passwordDaysLeft > 7) return;

    let title;
    if (passwordDaysLeft < 0) {
        title = t`Your password is expired`;
    } else if (passwordDaysLeft === 0) {
        title = t`Your password will expire today`;
    } else if (passwordDaysLeft === 1) {
        title = t`Your password will expire tomorrow`;
    } else {
        title = t({
            message: `Your password will expire in ${passwordDaysLeft} days`,
        });
    }

    infoNotification(
        {
            title,
            text: t`Please change your password.`,
        },
        PASSWORD_EXPIRED_MESSAGE_TIMEOUT_SECONDS,
    );
}

export function showPasswordExpiredToast() {
    errorNotification({
        title: t`Your password has expired`,
        text: t`Please change password in order to login.`,
    });
    trackUserError(
        // Duplicated error here so it will always be sent in English to the tracking system
        "Your password has expired",
        document.querySelector("[data-t-page]"),
    );
}

export function getNextPath() {
    const urlParams = new URLSearchParams(window.location.search);
    const nextPath = urlParams.get("next");
    if (nextPath && new URL(nextPath, window.location.href).origin !== window.location.origin) {
        // For security reasons, make sure we don't redirect to an external domain
        return null;
    }

    return nextPath;
}
